import { render, staticRenderFns } from "./UpdateShop.vue?vue&type=template&id=622bbf96&scoped=true"
import script from "./UpdateShop.vue?vue&type=script&lang=js"
export * from "./UpdateShop.vue?vue&type=script&lang=js"
import style0 from "./UpdateShop.vue?vue&type=style&index=0&id=622bbf96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622bbf96",
  null
  
)

export default component.exports